import React, { useState, useEffect, useContext } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { from } from "../../masterData";
import "./DatePicker.scss";

function SectionTool(props, setShown) {
  // const [checked, setChecked] = useState();
  const [show, setShow] = useState(false);
  const [showFrom, setShowFrom] = useState(false);
  const [fromYears, setFromYears] = useState();
  const [toYears, settoYears] = useState();
  const [fromIndex, setFromIndex] = useState();
  const [selectFromYear, setSelectFromYear] = useState({
    fromYear: "",
    fromMonth: "",
    toYear: "",
    toMonth: "",
    ongoing: "",
    ongoingText: "",
  });

  const [rightFromarrow, setRightFromarrow] = useState();
  const [rightToarrow, setRightToarrow] = useState();
  const [leftFromarrow, setLeftFromarrow] = useState();
  const [leftToarrow, setLeftToarrow] = useState();

  var fullMonth = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var earliestYear = 1946;
  let futureYear = new Date().getFullYear();
  var current_year = new Date().getFullYear();
  var current_month = new Date().getMonth();

  const handleClickYearTo = (data, index) => {
    props.dateHandler("toYear", data, props.index, props.sectionId);
    setSelectFromYear({ ...selectFromYear, toYear: data });
  };
  const handleClickMonthTo = (data, index) => {
    props.dateHandler("toMonth", data, props.index, props.sectionId);
    setSelectFromYear({ ...selectFromYear, toMonth: data });
  };
  const handleClickYear = (data, index) => {
    setFromIndex(index);
    props.dateHandler("fromYear", data, props.index, props.sectionId);
    setSelectFromYear({ ...selectFromYear, fromYear: data });
  };
  const handleClickMonth = (data, index) => {
    props.dateHandler("fromMonth", data, props.index, props.sectionId);
    setSelectFromYear({ ...selectFromYear, fromMonth: data });
  };

  //
  const toArrowFunction = (value) => {
    if (props && props.response && props.response.dateRange) {
      let dateObject = props && props.response && props.response.dateRange;
      let fromYear = dateObject && dateObject.fromYear;
      let toYear = dateObject && dateObject.toYear;
      let arr = [];
      var i;

      var yearinc;
      if (fromYear != "" && fromYear != null) {
        yearinc = fromYear;
      } else {
        yearinc = earliestYear + 1;
      }

      if (value == -1) {
        let l = toYears[0];
        let crctyear = l - 1;
        var maxOffset = 6; // how many fromYears you want. i will give 0 to 6
        for (i = 0; i <= maxOffset; i++) {
          var year = crctyear - i;
          arr.push(year);
        }
        if (yearinc == arr.find((e) => e == yearinc)) {
          setLeftToarrow(false);
        } else {
          setLeftToarrow(true);
        }
        if (futureYear == arr.find((e) => e == futureYear)) {
          setRightToarrow(false);
        } else {
          setRightToarrow(true);
        }
        settoYears(arr.reverse());
      } else if (value == 1) {
        let today = toYears[toYears.length - 1];
        for (i = 0; i < 7; i++) {
          today++;
          arr.push(today);
        }

        if (yearinc == arr.find((e) => e == yearinc)) {
          setLeftToarrow(false);
        } else {
          setLeftToarrow(true);
        }
        if (futureYear == arr.find((e) => e == futureYear)) {
          setRightToarrow(false);
        } else {
          setRightToarrow(true);
        }
        settoYears(arr);
      }
    }
  };

  const fromArrowFunction = (value) => {
    let dateObject = props && props.response && props.response.dateRange;
    let arr = [];
    var i;
    if (value == -1) {
      let l = fromYears[0];
      let crctyear = l - 1;
      var maxOffset = 10; // Change to whatever you want
      for (i = 0; i <= maxOffset; i++) {
        var year = crctyear - i;
        arr.push(year);
      }
      if (current_year == arr.find((e) => e == current_year)) {
        setRightFromarrow(false);
      } else {
        setRightFromarrow(true);
      }

      if (earliestYear == arr.find((e) => e == earliestYear)) {
        setLeftFromarrow(false);
      } else {
        setLeftFromarrow(true);
      }
      setFromYears(arr.reverse());
    } else if (value == 1) {
      let today = fromYears[fromYears.length - 1];
      let toYear = dateObject && dateObject.toYear;
      for (i = 0; i < 11; i++) {
        today++;
        arr.push(today);
      }
      if (current_year == arr.find((e) => e == current_year)) {
        setRightFromarrow(false);
      } else {
        setRightFromarrow(true);
      }
      if (toYear == arr.find((e) => e == toYear)) {
        setRightFromarrow(false);
      } else {
        setRightFromarrow(true);
      }
      if (earliestYear == arr.find((e) => e == earliestYear)) {
        setLeftFromarrow(false);
      } else {
        setLeftFromarrow(true);
      }
      setFromYears(arr);
    }
  };

  const [initialyear, setInitialYear] = useState();
  let current_year_db;
  let from_year;

  useEffect(() => {
    if (props && props.response && props.response.dateRange) {
      let dateObject = props && props.response && props.response.dateRange;
      hidefrom();
      showall();
      setShow(true);
      setShowFrom(true);
      if (dateObject && dateObject.isOnGoing) {
        console.log("comingggg");
        console.log(current_month, "current_month");
        setIsOnGoing(true);
        props.dateHandler("toYear", current_year, props.index, props.sectionId);
        props.dateHandler(
          "toMonth",
          fullMonth[current_month],
          props.index,
          props.sectionId
        );
        showall();
      }
      if (
        dateObject &&
        dateObject.onGoingText != "" &&
        dateObject &&
        dateObject.onGoingText != null
      ) {
        setMessage(dateObject && dateObject.onGoingText);
      } else {
        setMessage("Ongoing");
      }
    }
  }, []);

  const showall = (e) => {
    if (props && props.response && props.response.dateRange) {
      let dateObject = props && props.response && props.response.dateRange;
      let fromYear = dateObject && dateObject.fromYear;
      let toYear = dateObject && dateObject.toYear;

      let arr = [];
      var maxOffset = 10;
      let subtract_year;
      let roundUp;
      let multplied_year;
      if (toYear != "" && toYear != null) {
        current_year_db = toYear;
        setInitialYear(current_year_db);
      } else if (fromYear != "" && fromYear != null) {
        subtract_year = current_year - fromYear;
        roundUp = subtract_year / 11;
        roundUp = Math.ceil(roundUp);
        multplied_year = current_year - roundUp * 11;
        current_year_db = multplied_year + 11;
        setInitialYear(current_year_db);
      } else {
        current_year_db = current_year;
        setInitialYear(current_year_db);
      }

      for (var i = 0; i <= maxOffset; i++) {
        var year = current_year_db - i;
        arr.push(year);
      }
      if (fromYear != "" && fromYear != null) {
        if (
          current_year == arr.find((e) => e == current_year) &&
          earliestYear == arr.find((e) => e == earliestYear)
        ) {
          setRightFromarrow(false);
          setLeftFromarrow(false);
        } else if (earliestYear == arr.find((e) => e == earliestYear)) {
          setLeftFromarrow(false);
          setRightFromarrow(true);
        } else if (current_year == arr.find((e) => e == current_year)) {
          setRightFromarrow(false);
          setLeftFromarrow(true);
        } else if (toYear == arr.find((e) => e == toYear)) {
          setRightFromarrow(false);
          setLeftFromarrow(true);
        } else {
          setRightFromarrow(true);
          setLeftFromarrow(true);
        }
      } else if (toYear != "" && toYear != null) {
        if (
          current_year == arr.find((e) => e == current_year) &&
          earliestYear == arr.find((e) => e == earliestYear)
        ) {
          setRightFromarrow(false);
          setLeftFromarrow(false);
        } else if (earliestYear == arr.find((e) => e == earliestYear)) {
          setLeftFromarrow(false);
          setRightFromarrow(true);
        } else if (current_year == arr.find((e) => e == current_year)) {
          setRightFromarrow(false);
          setLeftFromarrow(true);
        } else if (toYear == arr.find((e) => e == toYear)) {
          setRightFromarrow(false);
          setLeftFromarrow(true);
        } else {
          setRightFromarrow(true);
          setLeftFromarrow(true);
        }
      } else {
        setLeftFromarrow(true);
      }
      setFromYears(arr.reverse());
    }

    setShow(true);
    setShowFrom(true);
  };

  const hidefrom = () => {
    if (props && props.response && props.response.dateRange) {
      let dateObject = props && props.response && props.response.dateRange;
      let fromYear = dateObject && dateObject.fromYear;
      let toYear = dateObject && dateObject.toYear;
      let yearsArray = [];
      setShowFrom(false);
      //   setOngoingtext(false);

      let currentYear;
      let CurrentDate;
      if (fromYear) {
        currentYear = fromYear;
        CurrentDate = currentYear - 1;
      } else {
        CurrentDate = earliestYear;
      }

      var maxOffset = 7;
      for (var i = 0; i < maxOffset; i++) {
        CurrentDate++;
        yearsArray.push(CurrentDate);
      }
      if (fromYear != "") {
        // if (
        //   toYear == yearsArray.find((e) => e == toYear) &&
        //   fromYear == yearsArray.find((e) => e == fromYear)
        // ) {
        //   setRightToarrow(false);
        //   setLeftToarrow(false);
        // } else
        if (fromYear == current_year) {
          setRightToarrow(false);
          setLeftToarrow(true);
        } else if (fromYear == yearsArray.find((e) => e == fromYear)) {
          setRightToarrow(true);
          setLeftToarrow(false);
        }
        settoYears(yearsArray);
      } else {
        if (earliestYear == yearsArray.find((e) => e == earliestYear)) {
          setRightToarrow(true);
        }
        settoYears(yearsArray);
      }
    }
  };

  const [isOnGoing, setIsOnGoing] = useState(false);

  const [message, setMessage] = useState("");
  const setMessageongoing = (e) => {
    setMessage(e.target.value);
    // setSelectFromYear({ ...selectFromYear, ongoingText: e.target.value });
  };
  const handleBlur = (e) => {
    props.dateHandler(
      "onGoingText",
      e.target.value,
      props.index,
      props.sectionId
    );
  };
  const handleOnGoing = (e) => {
    setIsOnGoing((current) => !current);

    props.dateHandler("isOnGoing", !isOnGoing, props.index, props.sectionId);
    props.dateHandler("toYear", current_year, props.index, props.sectionId);
    props.dateHandler(
      "toMonth",
      fullMonth[current_month],
      props.index,
      props.sectionId
    );
  };

  useEffect(() => {
    if (props && props.isSelectedFrom) {
      setShowFrom(true);
    } else {
      setShowFrom(true);
    }
  }, [props.isSelectedFrom]);

  return (
    <OutsideClickHandler
      onOutsideClick={(e, value) => {
        const parentWithClass = e.target.closest(".Datepicker_wrapper");
        const anotherParentWithClass = e.target.closest(".date-picker-icon");
        if (
          props &&
          props.showDatePicker &&
          parentWithClass == null &&
          anotherParentWithClass == null
        ) {
          props.setShowDatePicker(false);
        }
      }}
    >
      <div>
        <>
          <div className="Datepicker_wrapper">
            <div className="buttonalign">
              {showFrom == true ? (
                <>
                  <span className="btncolor" onClick={(e) => showall(e)}>
                    From
                  </span>

                  <span className="btnclr2" onClick={() => hidefrom()}>
                    To
                  </span>
                </>
              ) : (
                <>
                  <span className="btnclr2" onClick={(e) => showall(e)}>
                    From
                  </span>

                  <span className="btncolor" onClick={() => hidefrom()}>
                    To
                  </span>
                </>
              )}
            </div>
            {showFrom === true && (
              <>
                <div className="yearslist">
                  {leftFromarrow === true ? (
                    <>
                      <i
                        value="minus"
                        class="fa fa-arrow-left"
                        style={{ padding: "4px" }}
                        onClick={() => fromArrowFunction(-1)}
                      ></i>
                    </>
                  ) : (
                    <>
                      <i
                        value="minus"
                        class="fa fa-arrow-left"
                        style={{
                          padding: "4px",
                          cursor: "not-allowed",
                          opacity: 0.5,
                        }}
                        // onClick={() => fromArrowFunction()}
                      ></i>
                    </>
                  )}
                  {rightFromarrow === true ? (
                    <>
                      <i
                        value="plus"
                        class="fa fa-arrow-right"
                        style={{ padding: "4px" }}
                        onClick={() => fromArrowFunction(1)}
                      ></i>
                    </>
                  ) : (
                    <>
                      <i
                        value="plus"
                        class="fa fa-arrow-right"
                        style={{
                          padding: "4px",
                          cursor: "not-allowed",
                          opacity: 0.5,
                        }}
                        // onClick={() => fromArrowFunction()}
                      ></i>
                    </>
                  )}
                  {fromYears &&
                    fromYears.reverse() &&
                    fromYears.reverse().map((data, index, arr) => {
                      let dateObject =
                        props && props.response && props.response.dateRange;
                      let fromYear = dateObject && dateObject.fromYear;
                      let toYear = dateObject && dateObject.toYear;
                      if (data > current_year) {
                        return;
                      }
                      return fromYear == data ? (
                        <div
                          onClick={(e) => handleClickYear(data, index)}
                          className="eachyear selectedYear"
                        >
                          {data}
                        </div>
                      ) : (
                        <div
                          onClick={(e) => handleClickYear(data, index)}
                          className="eachyear "
                        >
                          {data}
                        </div>
                      );
                    })}
                </div>
                <div>
                  <div className="monthslist">
                    {fullMonth.map((data, index, arr) => {
                      let dateObject =
                        props && props.response && props.response.dateRange;
                      let fromMonth = dateObject && dateObject.fromMonth;
                      let fromYear = dateObject && dateObject.fromYear;
                      let fromMonthIndex = fullMonth.findIndex(
                        (x) => x == dateObject?.fromMonth
                      );
                      let toMonthIndex = fullMonth.findIndex(
                        (x) => x == dateObject?.toMonth
                      );
                      let toMonth = dateObject && dateObject.toMonth;
                      let toYear = dateObject && dateObject.toYear;
                      console.log(
                        fromMonth,
                        fromYear,
                        toMonth,
                        toYear,
                        fromMonthIndex,
                        toMonthIndex,
                        dateObject,
                        fullMonth
                      );
                      return fromYear && fromYear == toYear ? (
                        toMonthIndex < index && toMonthIndex != -1 ? (
                          fromMonth == data ? (
                            <div
                              onClick={(e) => handleClickMonth(data, index)}
                              className="eachyear selectedYear"
                            >
                              {data}
                            </div>
                          ) : (
                            <div
                              //   onClick={(e) => handleClickMonth(data, index)}
                              className="eachyear "
                              style={{
                                // padding: "4px",
                                cursor: "not-allowed",
                                opacity: 0.3,
                              }}
                            >
                              {data}
                            </div>
                          )
                        ) : current_month < index && current_year == toYear ? (
                          fromMonth == data ? (
                            <div
                              onClick={(e) => handleClickMonth(data, index)}
                              className="eachyear selectedYear"
                            >
                              {data}
                            </div>
                          ) : (
                            <div
                              //   onClick={(e) => handleClickMonth(data, index)}
                              className="eachyear "
                              style={{
                                // padding: "4px",
                                cursor: "not-allowed",
                                opacity: 0.3,
                              }}
                            >
                              {data}
                            </div>
                          )
                        ) : fromMonth == data ? (
                          <div
                            onClick={(e) => handleClickMonth(data, index)}
                            className="eachyear selectedYear"
                          >
                            {data}
                          </div>
                        ) : (
                          <div
                            onClick={(e) => handleClickMonth(data, index)}
                            className="eachyear"
                          >
                            {data}
                          </div>
                        )
                      ) : //New
                      current_year == fromYear ? (
                        current_month < index ? (
                          fromMonth == data ? (
                            <div
                              onClick={(e) => handleClickMonth(data, index)}
                              className="eachyear selectedYear"
                            >
                              {data}
                            </div>
                          ) : (
                            <div
                              //   onClick={(e) => handleClickMonth(data, index)}
                              className="eachyear "
                              style={{
                                // padding: "4px",
                                cursor: "not-allowed",
                                opacity: 0.3,
                              }}
                            >
                              {data}
                            </div>
                          )
                        ) : fromMonth == data ? (
                          <div
                            onClick={(e) => handleClickMonth(data, index)}
                            className="eachyear selectedYear"
                          >
                            {data}
                          </div>
                        ) : (
                          <div
                            onClick={(e) => handleClickMonth(data, index)}
                            className="eachyear"
                          >
                            {data}
                          </div>
                        )
                      ) : //end of current year
                      fromMonth == data ? (
                        <div
                          onClick={(e) => handleClickMonth(data, index)}
                          className="eachyear selectedYear"
                        >
                          {data}
                        </div>
                      ) : (
                        <div
                          onClick={(e) => handleClickMonth(data, index)}
                          className="eachyear"
                        >
                          {data}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            )}
            {showFrom === false && (
              <>
                <div style={{ position: "relative" }}>
                  <div>
                    <input
                      className="ongoingbox"
                      type="text"
                      value={message}
                      disabled={isOnGoing ? false : true}
                      onChange={(e) => setMessageongoing(e)}
                      onBlur={(e) => handleBlur(e)}
                      placeholder="Ongoing"
                    />
                  </div>

                  <div className="switchyear">
                    <input
                      onClick={(e) => handleOnGoing(e)}
                      type="checkbox"
                      id="switch"
                      class="checkbox"
                      checked={isOnGoing}
                    />
                    <label for="switch" class="toggle"></label>
                  </div>
                </div>

                {!isOnGoing ? (
                  <>
                    <div className="yearslistTo">
                      <div className="eachyear1">
                        {leftToarrow === true ? (
                          <>
                            <i
                              value="minus"
                              class="fa fa-arrow-left"
                              style={{ padding: "4px" }}
                              onClick={() => toArrowFunction(-1)}
                            ></i>
                          </>
                        ) : (
                          <>
                            <i
                              value="minus"
                              class="fa fa-arrow-left"
                              style={{
                                padding: "4px",
                                cursor: "not-allowed",
                                opacity: 0.5,
                              }}
                              // onClick={() => toArrowFunction()}
                            ></i>
                          </>
                        )}
                        {rightToarrow === true ? (
                          <>
                            <i
                              value="plus"
                              class="fa fa-arrow-right"
                              style={{ padding: "4px" }}
                              onClick={() => toArrowFunction(1)}
                            ></i>
                          </>
                        ) : (
                          <>
                            <i
                              value="plus"
                              class="fa fa-arrow-right"
                              style={{
                                padding: "4px",
                                cursor: "not-allowed",
                                opacity: 0.5,
                              }}
                              // onClick={() => toArrowFunction()}
                            ></i>
                          </>
                        )}
                      </div>
                      {toYears &&
                        toYears.reverse() &&
                        toYears.reverse().map((data, index, arr) => {
                          let dateObject =
                            props && props.response && props.response.dateRange;
                          let fromYear = dateObject && dateObject.fromYear;
                          let toYear = dateObject && dateObject.toYear;
                          if (data > current_year) {
                            return;
                          }
                          return toYear == data ? (
                            <div
                              onClick={(e) => handleClickYearTo(data, index)}
                              className="eachyear selectedYear"
                            >
                              {data}
                            </div>
                          ) : (
                            <div
                              onClick={(e) => handleClickYearTo(data, index)}
                              className="eachyear"
                            >
                              {data}
                            </div>
                          );
                        })}
                    </div>
                    <div>
                      <div className="monthslist">
                        {selectFromYear.fromYear == selectFromYear.toYear}

                        {fullMonth.map((data, index, arr) => {
                          let dateObject =
                            props && props.response && props.response.dateRange;
                          let fromYear = dateObject && dateObject.fromYear;
                          let fromMonthIndex = fullMonth.findIndex(
                            (x) => x == dateObject?.fromMonth
                          );
                          let toMonth = dateObject && dateObject.toMonth;
                          let toYear = dateObject && dateObject.toYear;

                          return fromYear == toYear ? (
                            fromMonthIndex > index ? (
                              toMonth == data ? (
                                <div
                                  onClick={(e) =>
                                    handleClickMonthTo(data, index)
                                  }
                                  className="eachyear selectedYear"
                                >
                                  {data}
                                </div>
                              ) : (
                                <div
                                  //   onClick={(e) => handleClickMonth(data, index)}
                                  className="eachyear "
                                  style={{
                                    // padding: "4px",
                                    cursor: "not-allowed",
                                    opacity: 0.3,
                                  }}
                                >
                                  {data}
                                </div>
                              )
                            ) : current_month < index &&
                              current_year == toYear ? (
                              toMonth == data ? (
                                <div
                                  onClick={(e) =>
                                    handleClickMonthTo(data, index)
                                  }
                                  className="eachyear selectedYear"
                                >
                                  {data}
                                </div>
                              ) : (
                                <div
                                  //   onClick={(e) => handleClickMonth(data, index)}
                                  className="eachyear "
                                  style={{
                                    // padding: "4px",
                                    cursor: "not-allowed",
                                    opacity: 0.3,
                                  }}
                                >
                                  {data}
                                </div>
                              )
                            ) : toMonth == data ? (
                              <div
                                onClick={(e) => handleClickMonthTo(data, index)}
                                className="eachyear selectedYear"
                              >
                                {data}
                              </div>
                            ) : (
                              <div
                                onClick={(e) => handleClickMonthTo(data, index)}
                                className="eachyear"
                              >
                                {data}
                              </div>
                            )
                          ) : current_year == toYear ? (
                            current_month < index ? (
                              toMonth == data ? (
                                <div
                                  onClick={(e) =>
                                    handleClickMonthTo(data, index)
                                  }
                                  className="eachyear selectedYear"
                                >
                                  {data}
                                </div>
                              ) : (
                                <div
                                  //   onClick={(e) => handleClickMonth(data, index)}
                                  className="eachyear "
                                  style={{
                                    // padding: "4px",
                                    cursor: "not-allowed",
                                    opacity: 0.3,
                                  }}
                                >
                                  {data}
                                </div>
                              )
                            ) : toMonth == data ? (
                              <div
                                onClick={(e) => handleClickMonthTo(data, index)}
                                className="eachyear selectedYear"
                              >
                                {data}
                              </div>
                            ) : (
                              <div
                                onClick={(e) => handleClickMonthTo(data, index)}
                                className="eachyear"
                              >
                                {data}
                              </div>
                            )
                          ) : //end of current year
                          toMonth == data ? (
                            <div
                              onClick={(e) => handleClickMonthTo(data, index)}
                              className="eachyear selectedYear"
                            >
                              {data}
                            </div>
                          ) : (
                            <div
                              onClick={(e) => handleClickMonthTo(data, index)}
                              className="eachyear"
                            >
                              {data}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </>
            )}
          </div>
        </>
      </div>
    </OutsideClickHandler>
  );
}
export default SectionTool;
